import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import "./basicCustomTable.css"
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { MdFeedback } from "react-icons/md";
import { IoChatboxEllipses } from "react-icons/io5";
import PaymentHistoryRowActions from "./PaymentHistoryRowActions";


const ActionIcons = ({
  row, onView, onEdit, onDelete, onAddEmpoyee,onChat,onPay, onMarkManualPaid,
  tableName, customClass, canEdit, canView, canDelete
}) => {
  // fallback: if any of these are undefined → treat as true (allow)
  const allowView = typeof canView === 'undefined' ? true : canView;
  const allowEdit = typeof canEdit === 'undefined' ? true : canEdit;
  const allowDelete = typeof canDelete === 'undefined' ? true : canDelete;

  return (
    <div
      className={`flex gap-1 ${customClass}-body ${
        tableName === "Payment-history" ? "payment-history-actions-root" : ""
      }`}
    >
      {["user-management", "customer management", "order management", "order tracking", "Payments", "Incidents"].includes(tableName) && allowView && (
        <Tooltip title="View">
          <IconButton size="small" onClick={() => onView?.(row)}>
            <VisibilityIcon fontSize="small" color="primary" />
          </IconButton>
        </Tooltip>
      )}

      {["approval"].includes(tableName) && allowEdit && (
        <Tooltip title="Approve/Reject Request">
          <IconButton size="small" onClick={() => onView?.(row)}>
            <RuleFolderIcon fontSize="small" color="primary" />
          </IconButton>
        </Tooltip>
      )}

      {["user-management", "permission", "employee"].includes(tableName) && allowEdit && (
        <Tooltip title="Edit">
          <IconButton size="small" onClick={() => onEdit?.(row)}>
            <TbEdit color="action" className="dark:text-white text-xl" />
          </IconButton>
        </Tooltip>
      )}

      {["permission", "employee", "assign-employee"].includes(tableName) && allowDelete && (
        <Tooltip title="Delete">
          <IconButton size="small" onClick={() => onDelete?.(row)}>
            <DeleteIcon fontSize="small" color="error" />
          </IconButton>
        </Tooltip>
      )}

      {["wash_fold", "cloth_category", "cloth_name", "tailoring_type"].includes(tableName) && allowDelete && (
        <Tooltip title="Delete">
          <IconButton size="small" onClick={() => onDelete?.(row)}>
            <RiDeleteBin6Fill className="dark:text-white text-lg text-[#d32f2f]" />
          </IconButton>
        </Tooltip>
      )}

      {["role"].includes(tableName) && allowEdit && (
        <Tooltip title="Add Employee">
          <IconButton size="small" onClick={() => onAddEmpoyee?.(row)}>
            <PersonAddAltOutlinedIcon fontSize="small" className="dark:text-white" />
          </IconButton>
        </Tooltip>
      )}

       {["task_history"].includes(tableName)  && (
        <Tooltip title="View Feedback">
          <IconButton size="small" onClick={() => onView?.(row)}>
            <MdFeedback fontSize="medium" className="dark:text-white" />
          </IconButton>
        </Tooltip>
      )}
        {["order management"].includes(tableName)  && (
        <Tooltip title="Chat with Customer">
          <IconButton size="small" onClick={() => onChat?.(row)}>
            <IoChatboxEllipses fontSize="medium" className="dark:text-white" />
          </IconButton>
        </Tooltip>
      )}
      {["Payment-history"].includes(tableName) && (
        <PaymentHistoryRowActions
          row={row}
          onProcessPayout={onPay}
          onMarkManuallyPaid={onMarkManualPaid}
        />
      )}

    </div>
  );
};

export default ActionIcons;

